import React, {Component} from 'react';
import ReactTable from "react-table";
import {filterCaseInsensitive} from "../shared/tableFunctions";
import FuseTheme from "../global/theme";

const styles = {
    tableHeaderTitle: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontWeight: '400',
        margin: 0,
        padding: '0.5em 1em'
    },
    wrapText: {wordWrap: 'break-word'},
    dialogContent: {maxWidth: '70%'},
    tableHeader: {
        position: 'relative',
        backgroundColor: FuseTheme.palette.pickerHeaderColor,
        color: FuseTheme.palette.alternateTextColor,
        fontWeight: '400',
        margin: '20px 0 20px 0',
        padding: '0.5em 1em'
    },
    paymentLogHeader: {
        background: 'rgb(117, 117, 117)',
        padding: '.5em 1em',
        color: '#fff'
    },
    transactionRow: {
        display: 'flex',
        width: '100%',
        borderBottom: '1px solid rgb(117, 117, 117)',
    },
    transactionTitle: {
        flex: 1,
        fontWeight: 600,
        padding: '0.5em 1em',
        borderRight: '1px solid rgb(117, 117, 117)'
    },
    transactionValue: {
        flex: 2,
        padding: '0.5em 1em'
    }
};

class DialogPaymentSeq extends Component {
    render() {

        const {
            data,
            creditList,
            handleSortOrFilterChange
        } = this.props;

        // ReactTable headers and columns for Table
        const tableCreditsColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Id',
                        accessor: 'id',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Currency',
                        accessor: 'currency',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Location',
                        accessor: 'location',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Register',
                        accessor: 'register',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Amount',
                        accessor: 'amount',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Price',
                        accessor: 'subtotal',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Tax',
                        accessor: 'tax',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Mode',
                        accessor: 'mode',
                        style: styles.wrapText,
                    },
                    {
                        Header: 'Transaction Date',
                        accessor: 'transaction_date_string',
                        style: styles.wrapText,
                    },
                ]
            }
        ];

        return (
            <div className="reports-custom-table-container">
                <div className="reports-table-title" style={styles.tableHeaderTitle}>
                    <h3 style={styles.tableHeaderTitle}>
                        <span>Payment Log</span>
                    </h3>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Location</div>
                    <div style={styles.transactionValue}>{data.location}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Register</div>
                    <div style={styles.transactionValue}>{data.register}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Transaction Date</div>
                    <div style={styles.transactionValue}>{data.transaction_date_string}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Payment Seq</div>
                    <div style={styles.transactionValue}>{data.payment_seq}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Sale Seq</div>
                    <div style={styles.transactionValue}>{data.sale_seq}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Transaction</div>
                    <div style={styles.transactionValue}>{data.transaction}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Transaction Type</div>
                    <div style={styles.transactionValue}>{data.transaction_type}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Currency</div>
                    <div style={styles.transactionValue}>{data.currency}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Subtotal</div>
                    <div style={styles.transactionValue}>{data.subtotal}</div>
                </div>
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Tax</div>
                    <div style={styles.transactionValue}>{data.tax}</div>
                </div>

                {data.card_type &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Card Type</div>
                    <div style={styles.transactionValue}>{data.card_type}</div>
                </div>
                }
                {data.card_last4 &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>CC Last 4</div>
                    <div style={styles.transactionValue}>{data.card_last4}</div>
                </div>
                }
                {data.card_type &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Card Data Source</div>
                    <div style={styles.transactionValue}>{data.card_type}</div>
                </div>
                }
                {data.pn_ref &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Pnref</div>
                    <div style={styles.transactionValue}>{data.pn_ref}</div>
                </div>
                }
                {data.card_last_name &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Last Name</div>
                    <div style={styles.transactionValue}>{data.card_last_name}</div>
                </div>
                }
                {data.card_first_name &&
                <div style={{...styles.transactionRow, ...styles.rowBg}}>
                    <div style={styles.transactionTitle}>First Name</div>
                    <div style={styles.transactionValue}>{data.card_first_name}</div>
                </div>
                }
                {data.authcode &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Auth</div>
                    <div style={styles.transactionValue}>{data.authcode}</div>
                </div>
                }
                <div style={{...styles.transactionRow, ...styles.rowBg}}>
                    <div style={styles.transactionTitle}>Mode</div>
                    <div style={styles.transactionValue}>{data.mode}</div>
                </div>
                {data.card_status &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Status</div>
                    <div style={styles.transactionValue}>{data.card_status}</div>
                </div>
                }
                {data.message &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Message</div>
                    <div style={styles.transactionValue}>{data.message}</div>
                </div>
                }
                {data.response_message &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Resp Message</div>
                    <div style={styles.transactionValue}>{data.response_message}</div>
                </div>
                }
                {data.code &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Code</div>
                    <div style={styles.transactionValue}>{data.code}</div>
                </div>
                }
                {data.ext_data &&
                <div style={styles.transactionRow}>
                    <div style={styles.transactionTitle}>Ext Data</div>
                    <div style={styles.transactionValue}>{data.ext_data}</div>
                </div>
                }

                {creditList.length > 0 &&
                <div>
                    <div className="reports-table-title" style={styles.tableHeader}>
                        <h3 style={styles.tableHeaderTitle}>
                            <span>Credits For Payment {data.payment_seq}</span>
                        </h3>
                    </div>
                    <ReactTable
                        key="table-transaction-log-report"
                        data={creditList}
                        columns={tableCreditsColumns}
                        defaultPageSize={100000}
                        showPagination={false}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => handleSortOrFilterChange(e, this.creditReactTable)}
                        onFilteredChange={(e) => handleSortOrFilterChange(e, this.creditReactTable)}
                        ref={(r) => this.creditReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow"
                    />
                </div>
                }
            </div>
        );
    }
}

export default DialogPaymentSeq;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogPaymentSeq.js